import PropTypes from 'prop-types';
import { reaction, action } from 'mobx';
import { PropTypes as MobxPropTypes } from 'mobx-react';
import { apiCall } from '../../API';
import AsyncActionStore from '../AsyncActionStore';
import EntityFormStore from '../helpers/EntityFormStore';
import MenuStore from '../MenuStore';
import TextStore from '../helpers/TextStore';
import CustomizeBrowserBarStore from './CustomizeBrowserBarStore';
import CustomizeContentFilteringStore from './CustomizeContentFilteringStore';
import CustomizeExitIsolationStore from './CustomizeExitIsolationStore';
import CustomizeMaliciousThreatStore from './CustomizeMaliciousThreatStore';
import CustomizeRegistrationNoticeStore from './CustomizeRegistrationNoticeStore';

export default class CustomizeUIStore extends EntityFormStore {
    static _PropType = {
        ...EntityFormStore._PropType,
        contentFiltering: CustomizeContentFilteringStore.PropType,
        maliciousThreat: CustomizeMaliciousThreatStore.PropType,
        browserBarOptions: CustomizeBrowserBarStore.PropType,
        exitMessage: CustomizeExitIsolationStore.PropType,
        registrationNotice: CustomizeRegistrationNoticeStore.PropType,
        browserStoresInitStatus: AsyncActionStore.PropType,
        loadBrowserStoresInit: PropTypes.func,
        search: TextStore.PropTypes,
        menu: MenuStore.PropType,
        readOnlyModal: MenuStore.PropType,
        filteredList: MobxPropTypes.arrayOrObservableArray,
    };

    static PropType = PropTypes.shape(CustomizeUIStore._PropType);

    constructor(data = { }) {
        super({}, /** @class CustomizeUIStore */{
            contentFiltering: new CustomizeContentFilteringStore(),
            maliciousThreat: new CustomizeMaliciousThreatStore(),
            browserBarOptions: new CustomizeBrowserBarStore(),
            exitMessage: new CustomizeExitIsolationStore(),
            registrationNotice: new CustomizeRegistrationNoticeStore(),
            getItemStores: () => [
                this.contentFiltering,
                this.maliciousThreat,
                this.browserBarOptions,
                this.exitMessage,
                this.registrationNotice,
            ].filter((s) => s.visible.getValue()),

            apiBrowserStoresInit: apiCall('/console/customize_ui_api/browser_stores_init'),
            browserStoresInitStatus: new AsyncActionStore(),
            loadBrowserStoresInit: action(() => {
                if (!this.browserStoresInitStatus.isLoading) {
                    this.browserStoresInitStatus.setLoading(this.apiBrowserStoresInit(), true);
                }
                return this.browserStoresInitStatus.promise;
            }),

            filteredList: [],
            search: new TextStore(),
            menu: new MenuStore(),
            apiLoad: () => Promise.all([
                ...this.getItemStores().map((store) => store.load()),
                this.loadBrowserStoresInit(),
            ]),
            readOnlyModal: new MenuStore(),
        }, data);

        this.setFilteredList();
        reaction(() => this.search.getValue(), this.setFilteredList);
        reaction(() => this.getItemStores(), this.setFilteredList);

        // refresh data for preview when browser bar options are updated
        reaction(() => this.browserBarOptions.updateStatus.successCount, this.loadBrowserStoresInit);
    }

    setFilteredList = action(() => {
        const value = this.search.getValue().toLowerCase();
        this.filteredList.replace(this.getItemStores().filter((item) =>
            !value || item.metadata.name.toLowerCase().includes(value)));
    });
}
